import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function ContactSection() {
  return (
    <section className="py-16 text-center bg-transparent">
      <h2 className="text-3xl font-bold text-purple-300 mb-6">Contact</h2>
      <div className="flex justify-center gap-8 text-3xl">
        <a
          href="https://github.com/BlackSkull457"
          className="hover:text-purple-400 transition-colors duration-300"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub />
        </a>
        <a
          href="https://linkedin.com/in/daniel-liem-ab6a032bb"
          className="hover:text-purple-400 transition-colors duration-300"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin />
        </a>
        <a
          href="mailto:danielgiovaniliem457@gmail.com"
          className="hover:text-purple-400 transition-colors duration-300"
        >
          <FaEnvelope />
        </a>
      </div>
    </section>
  );
}
